import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_CUSTOMERS_QUERY } from "../../graphql/Customers/Customers.graphql";

function CustomerNameSelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  required,
  readOnly
}) {
  const { data, loading, error } = useQuery(ALL_CUSTOMERS_QUERY, { variables });
  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={error ? "danger" : ""}
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            required={required}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.Customers.map((Customer, i) => (
                <Select.Option
                  key={`customer-select-${i}`}
                  value={Customer.RecId}
                >
                  {Customer.Name}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

CustomerNameSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  readOnly: PropTypes.bool
};

CustomerNameSelect.defaultProps = {
  variables: {
    where: { Active: true, OrderCust: true },
    orderByMulti: ["CustomerNo_ASC"]
  }
};
export default CustomerNameSelect;
